import * as Yup from "yup";
const VALIDATE_MESSAGE = {
  required: "Thông tin bắt buộc"
};

export const ValidateSchema = Yup.object().shape({
  ngay: Yup.number()
    .nullable()
    .required(VALIDATE_MESSAGE.required),
  thang: Yup.number()
    .nullable()
    .required(VALIDATE_MESSAGE.required),
  nam: Yup.number()
    .nullable()
    .required(VALIDATE_MESSAGE.required)
});
